import api from "./Api";

class DistribuidorService {
  GetDistribuidor(payload) {
    return api.get("/v1/distribuidor/" + payload).then((response) => {
      return response.data;
    });
  }

  PostDistribuidor(payload) {
    return api.post("/v1/distribuidor/", payload).then((response) => {
      return response.data;
    });
  }

  PutDistribuidor(payload) {
    return api.put("/v1/distribuidor/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteDistribuidor(payload) {
    return api.delete("/v1/distribuidor/" + payload).then((response) => {
      return response.data;
    });
  }

  GetDistribuidorOData(payload) {
    return api.get("/OData/distribuidor" + payload).then((response) => {
      return response.data;
    });
  }
}

export default new DistribuidorService();
